import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=f5786aae&scoped=true&"
var script = {}
import style0 from "./loader.vue?vue&type=style&index=0&id=f5786aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5786aae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f5786aae', component.options)
    } else {
      api.reload('f5786aae', component.options)
    }
    module.hot.accept("./loader.vue?vue&type=template&id=f5786aae&scoped=true&", function () {
      api.rerender('f5786aae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/loader.vue"
export default component.exports